var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.339 31.343",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.265,205.2a14.524,14.524,0,1,1-11.06-17.308h0A14.54,14.54,0,0,1,581.265,205.2m-10.809-18.428a15.668,15.668,0,1,0,11.927,18.675h0a15.687,15.687,0,0,0-11.927-18.674",
    transform: "translate(-551.411 -186.401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.356,204.693h-9.513a29.3,29.3,0,0,0,1.546-9.2l3.069,3.885.978-.819a.409.409,0,0,1,.577.053.325.325,0,0,1,.026.035l3.656,5.406a.411.411,0,0,1-.34.641m-21.843,0a.411.411,0,0,1-.319-.669l3.273-4.043a.412.412,0,0,1,.578-.062.419.419,0,0,1,.065.066l.971,1.236,6.966-7.913a.412.412,0,0,1,.582-.035.463.463,0,0,1,.049.052l1.413,1.789a29.4,29.4,0,0,1-4.717,9.575Zm4.017,5.828a1.866,1.866,0,1,1,1.87-1.861h0a1.866,1.866,0,0,1-1.87,1.861m9.7-20.793a13.007,13.007,0,0,0-11.8,22.1,3.022,3.022,0,0,1,2.08-.828h.008a3.041,3.041,0,0,1,2.508,1.334.291.291,0,0,0,.236.129l3.261.007a.686.686,0,0,1,.382.108.66.66,0,0,1,.245.8.643.643,0,0,1-.606.4h0l-4.813-.011v.361a13.008,13.008,0,1,0,8.5-24.4",
    transform: "translate(-551.764 -186.755)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill14);
export default __webpack_public_path__ + "static/media/skill14.7c045b1f.svg";
export { ForwardRef as ReactComponent };